import { Avatar, Badge, Button, CaretDownOutlined, Popover } from 'core-ui';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY } from 'src/constants/auth';
import { RoutePath } from 'src/enums/routePath';
import useHandleNetwork from 'src/hooks/useHandleNetwork';

const Header = () => {
  const handleLogout = () => {
    Cookies.remove(ACCESS_TOKEN_KEY);
    window.location.replace(RoutePath.LOGIN);
  };

  const { isOnline } = useHandleNetwork();

  return (
    <div className="h-[100%] flex items-center justify-between w-[100%]">
      {/* <Form.Item noStyle>
        <Input
          className="w-[40%] bg-[transparent]"
          prefix={
            <SearchOutlined
              style={{
                color: 'white'
              }}
            />
          }
        />
      </Form.Item> */}
      <div></div>

      <div className="flex items-center">
        <Popover
          placement="bottomRight"
          content={
            <Button type="text" size="small" danger onClick={handleLogout}>
              ログアウト
            </Button>
          }
        >
          <div className="flex cursor-pointer items-center">
            <Avatar
              size={32}
              style={{ border: '1px solid white', minWidth: '32px' }}
              src={''}
            >
              A
            </Avatar>

            <div className="mr-[20px] flex">
              <Badge
                dot={true}
                color="green"
                offset={[14, 10]}
                style={{
                  display: isOnline ? 'block' : 'none',
                  height: '10px',
                  width: '10px'
                }}
              >
                <div className="flex flex-col ml-[8px]">
                  <p className="leading-[20px] font-[700] text-white text-[16px] min-w-[60px]">
                    Admin
                  </p>
                </div>
              </Badge>
            </div>

            <CaretDownOutlined
              style={{
                color: 'white',
                marginLeft: '12px'
              }}
            />
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default Header;
